import React from 'react'

export default function ActionCard (props) {
    return (
    <div {...props} className={props.className ? props.className + " action-card" : "action-card"}><img src={props.img} alt="" /><span className={"text"}>{ props.text }</span></div>
    )
}
